
export const displayParkingResearchFromIntroSelector = ({displayParkingResearchFromIntro}) => displayParkingResearchFromIntro